module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-12-d07c0945d8586760c74a14e829baf1c4.jpg";